import { createContext, useContext } from 'react';
import { useAutomationEditor } from './useAutomationEditor';

type ContextValue = {
  editor: ReturnType<typeof useAutomationEditor>;
};

export const AutomationEditorContext = createContext<ContextValue | null>(null);

/**
 * Reads the automation-editor context, throwing a clear provider invariant if used outside an
 * AutomationEditorProvider instead of failing with an opaque TypeError on the nullable value.
 */
export function useAutomationEditorContext(): ContextValue {
  const context = useContext(AutomationEditorContext);
  if (context === null) {
    throw new Error('useAutomationEditorContext must be used within an AutomationEditorProvider');
  }
  return context;
}
